import { render, staticRenderFns } from "./myCollections.vue?vue&type=template&id=3a5a3846&scoped=true&"
import script from "./myCollections.vue?vue&type=script&lang=ts&"
export * from "./myCollections.vue?vue&type=script&lang=ts&"
import style0 from "./myCollections.vue?vue&type=style&index=0&id=3a5a3846&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a5a3846",
  null
  
)

export default component.exports